/**
 * ProtectedRoute component
 * Redirects unauthenticated users to login
 * @module components/protected/ProtectedRoute
 */

import React from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { DEFAULT_LANGUAGE } from '../../i18n';
import Spinner from '../ui/Spinner';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useSelector((state) => state.auth);
  const location = useLocation();
  const { lang } = useParams();
  const currentLang = lang || DEFAULT_LANGUAGE;

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={`/${currentLang}/login`} state={{ from: location }} replace />;
  }

  return children || <Outlet />;
};

export default ProtectedRoute;

// Developed and Designed by Trophy Developers
